/**
 * Check if the element is overflown
 */
export default function isOverflown(element, child) {
    return child
        ? child.clientHeight > element.clientHeight
        : element.scrollHeight > element.clientHeight;
}
